module.exports = __webpack_public_path__ + "img/20.35613eb4.jpg";